import { Component, OnInit} from '@angular/core';
@Component({
  selector: 'app-estandares-home',
  templateUrl: './estandares-home.component.html',
  styleUrls: ['./estandares-home.component.css']
})
export class EstandaresHomeComponent implements OnInit {

  secProd: boolean;
  botones: boolean;
  subSect: boolean;
  idSect: number;
  desc: string;

  subSectEs: boolean;
  estandar: boolean;
  estandarNB: string;
  listEstandar: boolean;
  estandarHeade:boolean;
  esmarca:boolean;

  padre: number;
  titlePadre: string;
  desEstandar:boolean;
  desEstandarMarca:boolean;
  codigoEC:string;
  tablaEstandar:boolean;
  marca:boolean;
  


  constructor() {
    this.secProd = false;
    this.botones = false;
    this.subSect = false;
    this.subSectEs = true;
    this.estandar = false;
    this.listEstandar = false;
    this.idSect = 0;
    this.desc = 'Sectores Productivos';
    this.estandarNB = 'Estándares Por Sector Productivo';
    this.padre = 0;
    this.desEstandar=false;
    this.tablaEstandar=false;
    this.desEstandarMarca=false;
    this.esmarca=false;
    this.marca=false;
  }

  ngOnInit(): void {
    
  }

  onDeesEstandarMarca(event){
   
 
    this.estandarNB = event.titlePadre;
    this.desEstandarMarca=true;
    this.titlePadre = event.titlePadre;
    this.codigoEC=event.padre;
     this.tablaEstandar=false;
     this.esmarca=false;
     this.marca=false;

  }

  estandarMarcaOnBack(event) {
    if (event === 0) {
      this.listEstandar = false;
      this.secProd = false;
      this.botones = false;
      this.subSect = false;
      this.subSectEs = true;
      this.estandar = false;
      this.listEstandar = false;
      this.idSect = 0;
      this.desc = 'Sectores Productivos';
      this.estandarNB = 'Estándares Por Sector Productivo';
      this.padre = 0;
      this.desEstandar=false;
      this.tablaEstandar=false;
      this.desEstandarMarca=false;
      this.esmarca=false;
      this.marca=false;
    } 
    else{
      this.secProd = false;
    this.subSect = false;
    this.subSectEs = false;
    this.estandar = false;
    this.listEstandar = false;
    this.desEstandar=false;
    this.desEstandarMarca=false;
     this.tablaEstandar=false;
     this.esmarca=true;
     this.marca=true;
    }
      
    
  }


 

}


